import { ElementProps } from "../../../types/common";

export const ArrowSuccessIcon = (props: ElementProps) => (
  <svg
    width={10}
    height={7}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.75.75 3.594 6 1.25 3.614"
      stroke="#03C57F"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
